module.exports = __webpack_public_path__ + "img/categorie-nous-contacter-famille-boutrais-small.80653077.jpg";